<template>
    <div class="auto-up-rv">
        <div :class="{
                'auto-up-rv-web': $detect == 'web',
                'auto-up-rv-mobile': $detect == 'mobile'
            }">
            <div :class="{
                    'row': $detect == 'web'
                }">
                <button class="btn-history-up btn-block mb-2"
                    @click="dialog = true" v-if="$detect == 'mobile'">
                    Lịch up tự động
                </button>
                <div :class="{
                        'col-8 pr-2': $detect == 'web',
                    }">
                    <div class="card-dashboard">
                        <div class="title-card p-10px" v-if="$detect == 'web'">
                            Đặt lịch tự động Up Rao vặt
                        </div>
                        <div :class="{
                                'body-card-auto p-10px vg-scrollbar': $detect == 'web'
                            }">
                            <div :class="{
                                    'list-rv': true,
                                    'mt-4': $detect == 'mobile',
                                }">
                                <p class="mb-0 fw-600">Danh sách tin auto up:</p>
                                <p class="item-auto-up" v-if="data.length == 1">
                                    <a :href="$linkUrl(data[0].link)" class="text-decoration-none" target="_blank">{{data[0].name}}</a>
                                </p>
                                <span class="item-auto-up-multiple" v-else>
                                    <a :href="$linkUrl(item.link)" class="text-decoration-none" target="_blank"
                                        v-for="(item, index) in data" :key="index">
                                        #{{item.id}},
                                    </a>
                                </span>
                            </div>
                            <div :class="{
                                    'form-auto-up mt-4': $detect == 'web'
                                }">
                                <div :class="{
                                        'd-flex': true,
                                        'justify-content-center': $detect == 'web',
                                        'mt-3 justify-content-around': $detect == 'mobile',
                                    }">
                                    <div :class="{
                                            'custom-control custom-radio': true,
                                            'custom-control-inline mr-5': $detect == 'web'
                                        }">
                                        <input type="radio"
                                            id="customRadioInline1"
                                            name="customRadioInline1"
                                            class="custom-control-input"
                                            v-model="classify" :value="1">
                                        <label class="custom-control-label"
                                            for="customRadioInline1">
                                            Đặt khoảng cách cho mỗi lần up
                                        </label>
                                    </div>
                                    <div :class="{
                                            'custom-control custom-radio': true,
                                            'custom-control-inline ml-5 mr-0': $detect == 'web'
                                        }">
                                        <input type="radio"
                                            id="customRadioInline2"
                                            name="customRadioInline1"
                                            class="custom-control-input"
                                            v-model="classify" :value="2">
                                        <label class="custom-control-label"
                                            for="customRadioInline2">
                                            Đặt lịch chi tiết cho mỗi lần up
                                        </label>
                                    </div>
                                </div>
                                <div :class="{
                                        'select-up-detail mt-4':true,
                                        'mx-5': $detect == 'web',
                                        }">
                                    <p class="mb-0 fs-14px fw-600 mb-2">Số điểm bạn muốn sử dụng:</p>
                                    <ldc-select-show-option
                                        class="price"
                                        v-model="sPrice"
                                        :showPlaceholder="false">
                                        <ldc-option-show
                                            v-for="(suggestPrice, index) in suggestPrices" :key="index"
                                            :value="suggestPrice.value"
                                            :label="suggestPrice.label"/>
                                    </ldc-select-show-option>
                                </div>
                                <autoupRange
                                    :price.sync="sPrice"
                                    :rv="data"
                                    v-show="classify == 1"/>
                                <autoUpDetail
                                    :price.sync="sPrice"
                                    :rv="data"
                                    v-show="classify == 2"/>
                            </div>
                        </div>
                    </div>
                </div>
                <historyUp
                    :rv="data"
                    :dialog.sync="dialog"/>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
        autoUpDetail: () => import('@/components/profile/raovat/autoUpDetail'),
        autoupRange: () => import('@/components/profile/raovat/autoupRange'),
        historyUp: () => import('@/components/profile/raovat/historyUp'),
    },
    data() {
        return {
            dialog: false,
            data: [],
            classify: 2,
            sPrice: 100000,
            suggestPrices: [],
        }
    },
    async created() {
        let id = this.$route.query.id;
        if(!id){
            this.$router.push({
                name: 'raovat-auto-up',
            });
            this.$message({
                message: 'Vui lòng chọn tin cần up tự động',
                type:'warning',
                center: true,
            });
        }
        id = id.toString().split(',');
        let idCall = [];
        id.map(item => {
            if(item && idCall.includes(item) !== true) idCall.push(item)
        })
        await apiGet('/v2/profile/raovat/where_in', {
            id: idCall,
        }).then(res => {
            this.data = res.data;
            if(res.data.length == 0){
                this.$router.push({
                    name: 'raovat-auto-up',
                });
                this.$message({
                    message: 'Tin rao không tồn tại, Vui lòng chọn tin rao',
                    type:'warning',
                    center: true,
                });
            }
        });
        getMoney();
    },
    watch: {
        money: {
            handler(val){
                let price = [
                    {
                        value: 50000,
                        label: '50.000'
                    },
                    {
                        value: 100000,
                        label: '100.000'
                    },
                    {
                        value: 200000,
                        label: '200.000'
                    },
                    {
                        value: 500000,
                        label: '500.000'
                    },
                    {
                        value: 1000000,
                        label: '1.000.000'
                    },
                    {
                        value: 2000000,
                        label: '2.000.000'
                    },
                ];
                this.suggestPrices = [];
                price.map(item => {
                    // if(val.money >= item.value){
                        this.suggestPrices.push(item)
                    // }
                })
            },
            deep: true,
        }
    },
    computed: {
        config(){
            return this.$store.state.config;
        },
        money(){
            return this.$store.state.money;
        },
    },
    methods: {
        popupHistory() {
            this.dialog = true;
        },
        closeDialog() {
            this.dialog = false;
        }
    },
    mounted() {
        if(this.$detect == 'web'){
            document.querySelector("[content-dashboard]").style.padding = "16px";
        }
    },
    beforeDestroy() {
        if(this.$detect == 'web'){
            document.querySelector("[content-dashboard]").style.padding = "16px 16px 48.8px";
        }
    }
}
</script>
<style lang="scss">
    .auto-up-rv {
        box-shadow: none !important;
        background: transparent !important;
        padding: 0 !important;
        border-radius: 0 !important;
        .auto-up-rv-web {
            .card-dashboard {
                box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
                background: #fff;
                border-radius: 5px;
                min-height: calc(100vh - 82px);
                overflow: hidden;
                .title-card {
                    border-bottom: 1px solid #0c81f6;
                }
                .body-card-auto {
                    height: calc(100vh - 127px);
                    overflow: auto;
                    .list-rv {
                        .item-auto-up {
                            a {
                                -webkit-line-clamp: 1;
                                -webkit-box-orient: vertical;
                                display: -webkit-box;
                                overflow: hidden;
                            }
                        }
                    }
                    .form-auto-up {
                        .select-auto-up {
                            width: 250px;
                            .ldc-input {
                                border: 1px solid #ced4da !important;
                                &::placeholder {
                                    color: #495057;
                                    opacity: 1;
                                }
                            }
                            svg {
                                fill: #343a40 !important;
                            }
                        }
                    }
                }
            }
        }
        .auto-up-rv-mobile {
            .btn-history-up {
                border: 1px solid #ced4da;
                background: #fff;
                border-radius: 4px;
                height: 42px;
                line-height: 42px;
                color: #606266;
            }
            .list-rv {
                .item-auto-up {
                    a {
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        display: -webkit-box;
                        overflow: hidden;
                    }
                }
            }
        }
        .select-up-detail {
            .ldc-select-show-option {
                padding: 0 !important;
                .option {
                    padding: 5px 0 !important;
                    border-radius: 4px !important;
                    font-size: 14px !important;
                    cursor: pointer;
                    width: 90px;
                    text-align: center;
                }
                .bg-primary {
                    box-shadow: 0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08) !important;
                }
            }
        }
    }
</style>
